import { useHead } from '@unhead/vue'

export function useSeoMeta() {
  useHead({
    title: 'Collaborative IT Solutions in Nepal | Detech Solution',
    meta: [
      {
        name: 'description',
        content:
          "Achieve your business goals with Detech Solution's cutting-edge IT services, including software development, consulting, and managed IT solutions in Nepal.",
      },
      {
        name: 'keywords',
        content:
          'IT consulting services in Nepal, Software development Nepal, IT solutions Lalitpur',
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: 'en_US' },
      { name: 'og:site_name', content: 'Detech Solution' },
      {
        property: 'og:title',
        content: 'Collaborative IT Solutions in Nepal | Detech Solution',
      },
      {
        property: 'og:description',
        content:
          'Detech Solution is an IT consulting firm. We help businesses and organizations to achieve their goals.',
      },
      {
        property: 'og:image',
        content: 'https://i.postimg.cc/yN4J7CC6/detech.webp',
      },
      {
        property: 'og:image:secure_url',
        content: 'https://i.postimg.cc/yN4J7CC6/detech.webp',
      },
      {
        property: 'og:image:alt',
        content: 'Detech Solution office banner showing teamwork and collaboration.',
      },
      { name: 'og:image:height', content: '630' },
      { name: 'og:image:width', content: '1200' },
      { name: 'og:image:type', content: 'image/png' },
      {
        property: 'twitter:title',
        content: 'Collaborative IT Solutions in Nepal | Detech Solution',
      },
      {
        property: 'twitter:description',
        content:
          'Detech Solution is an IT consulting firm. We help businesses and organizations to achieve their goals.',
      },
      {
        property: 'twitter:image',
        content: 'https://i.postimg.cc/yN4J7CC6/detech.webp',
      },
      {
        name: 'twitter:image:alt',
        content: 'Detech Solution team at work',
      },
      { name: 'theme-color', content: '#f1f5f9' }
    ],
    link: [
      { rel: 'canonical', href: 'https://www.detech.com.np' },
      { rel: 'alternate', hreflang: 'en', href: 'https://www.detech.com.np' },
      {
        rel: 'preload',
        as: 'image',
        href: 'https://i.postimg.cc/hvVXXJpf/home-age-banner.webp',
        fetchpriority: 'high',
        type: 'image/webp'
      }
    ]
  })
}
